import { useContext, useEffect } from 'react';

import { AnalyticsContext } from './analytics.context';

import { initializeAnalytics } from '../logrocket';
import { initializeSentry } from '../sentry/initializeSentry';

// Guards against React StrictMode double-invoke and provider re-renders so
// LogRocket/Sentry are only initialized once per app load.
let hasInitialized = false;

/**
 * Renders nothing. Initializes analytics (and then Sentry) using the hydrated
 * Analytics instance from context, so the persisted `analytics_enabled` flag is
 * respected. Must be mounted under `AnalyticsProvider` and `PersistGate`.
 */
export function AnalyticsInitializer() {
  const analytics = useContext(AnalyticsContext);

  useEffect(() => {
    if (hasInitialized || !analytics) {
      return;
    }
    hasInitialized = true;

    initializeAnalytics(analytics)
      .finally(() => initializeSentry(analytics))
      .catch(() => undefined);
  }, [analytics]);

  return null;
}
